import {Injectable} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {CacheService} from "@customcoding/shared";
import moment from "moment";

@Injectable({
	providedIn: 'root'
})
export class BlockOutDatesService {
	constructor(private http: HttpClient, private cache: CacheService) {
	}

	getAll() {
		return this.http.get(`/api/scap/block-out-date`);
	}

	getAllCached(){
		return this.cache.get(`/api/scap/block-out-date`,moment.duration(5,'minutes'));
	}

	getFilteredDates(count: number = null, isPaginated: boolean = false, companyId: number = null, startDate: string = null, endDate: string = null, creatorId: number = null) {
		return this.http.get(`/api/scap/block-out-date
			?isPaginated=${isPaginated ? '1' : '0'}
			${!!count ? '&count=' + count : ''}
			&filter[company_id]=${!!companyId ? companyId : ''}
			&filter[creator_id]=${!!creatorId ? creatorId : ''}
			&filter[startDate]=${!!startDate ? startDate : ''}
			&filter[endDate]=${!!endDate ? endDate : ''}
			`);
	}
}
